import { Category } from '@/types/category';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useMemo } from 'react';

import CategoryManagerOverviewCard from './index';

type Props = {
  category: Category;
  setOpenDeleteModal: () => void;
  setOpenArchiveModal: () => void;
  setOpenEditModal: () => void;
  isDragging?: boolean;
};

function SortableCategoryManagerOverviewCard({
  category,
  setOpenArchiveModal,
  setOpenDeleteModal,
  setOpenEditModal,
  isDragging = false,
}: Props) {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging: isSortableDragging,
  } = useSortable({ id: category.id });

  const style = useMemo(
    () => ({
      transform: CSS.Transform.toString(transform),
      transition,
      opacity: isDragging || isSortableDragging ? 0.5 : 1,
      cursor: isDragging ? 'grabbing' : 'grab',
    }),
    [transform, transition, isDragging, isSortableDragging],
  );

  return (
    <div ref={setNodeRef} style={style} {...attributes} {...listeners}>
      <CategoryManagerOverviewCard
        category={category}
        setOpenArchiveModal={setOpenArchiveModal}
        setOpenDeleteModal={setOpenDeleteModal}
        setOpenEditModal={setOpenEditModal}
      />
    </div>
  );
}

export default SortableCategoryManagerOverviewCard;
